import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getContactCaseCount } from 'services/ContactService'

export const useContactCaseCountQuery = (isEnabled = false) => {
  return useQuery({
    queryKey: reactQueryKeys.contactCaseCount(),
    queryFn: getContactCaseCount,
    enabled: isEnabled,
  })
}
